


function BlocHoraires() {

    let listHoraires = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]


    return (
        <div className="ligne-contrat">
            <div className="ligne-contrat-nom">

            </div>
            <div className="ligne-horaire-journee">
                <span></span>
                {listHoraires.map(h => <span><p>{h}h</p></span>)}

            </div>
        </div>
    );
}

export default BlocHoraires